import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { changeField } from 'publisher/actions/optInActions'
import { useFieldsStorage } from 'publisher/components/entities/Field/hooks/use-fields-storage'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/optIn/optInSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { CommonPublisherPhoneNumberFieldEntityOrSubEntity } from 'src/publisher/shared/components/field/common-publisher-phone-number-field-entity-or-sub-entity'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'

export interface PhoneNumberFieldProps {
  entity: FieldEntityInterface
}

const PhoneNumberField = ({ entity }: PhoneNumberFieldProps) => {
  const dispatch = useDispatch()
  const errors = useOptIn(optIn =>
    getFieldErrorsBySlug(optIn, FieldSlugEnum.PhoneNumber),
  )
  const phoneNumber = useOptIn(optIn =>
    getFieldValueBySlug(optIn, FieldSlugEnum.PhoneNumber),
  )

  const { isReady } = useFieldsStorage(entity.slug ?? '')

  return (
    <CommonPublisherPhoneNumberFieldEntityOrSubEntity
      entityOrSubEntity={entity}
      value={phoneNumber}
      onChange={value => dispatch(changeField(entity.slug, value))}
      errors={errors}
      isHidden={!isReady}
    />
  )
}

export default PhoneNumberField
